import { render, staticRenderFns } from "./ListOfAssets.vue?vue&type=template&id=bed3932c&scoped=true&"
import script from "./ListOfAssets.vue?vue&type=script&lang=ts&"
export * from "./ListOfAssets.vue?vue&type=script&lang=ts&"
import style0 from "./ListOfAssets.vue?vue&type=style&index=0&id=bed3932c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed3932c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bed3932c')) {
      api.createRecord('bed3932c', component.options)
    } else {
      api.reload('bed3932c', component.options)
    }
    module.hot.accept("./ListOfAssets.vue?vue&type=template&id=bed3932c&scoped=true&", function () {
      api.rerender('bed3932c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Reports/ListOfAssets.vue"
export default component.exports